module.exports = __webpack_public_path__ + "static/media/img_lounge.2c8a08b0.webp";